import { useState } from "react";
import { SortOrder, ListTableSort } from "sprint-common-web";

export interface OrderProxiesSectionFilters {
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: OrderProxiesSectionFilters = {
    sortBy: "updatedDate",
    sortOrder: "desc"
};

export const useOrderProxiesSectionFilters = () => {
    const [filters, setFilters] = useState<OrderProxiesSectionFilters>(defaultFilters);

    const setSort = ({ by: sortBy, order: sortOrder }: ListTableSort) => {
        setFilters((prevFilters: OrderProxiesSectionFilters) => ({
            ...prevFilters,
            sortBy,
            sortOrder,
            page: 1
        }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setSort,
        clearFilters
    };
};
